<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";
    
   export default {
      page: {
         title: "Users",
         meta: [
            {
               name: "description",
               content: appConfig.description,
            },
         ],
      },
      components: { Layout, PageHeader },
      data() {
         return {
            title: "Users",
            items: [
               {
                  text: "Users",
                  active: true,
               },                   
            ],
            patients: [],
            patient_status: {
               id: "",
               status: "",
            },
            listing_length: 10,
            keyword: '',
            status: '',
            from: null,
            to: null,
            total: null,
            pagination: {},
            token: "",
            errors: {},
            activate: false,
            deactivate: false,

            active_page_url: null,
         };
      },
      mounted() {
       this.clearLocalStorage();
      },
      created() {
         const savedFilters = localStorage.getItem("patient_filters");

         if (savedFilters) {
            const filters = JSON.parse(savedFilters);

            // Restore values
            this.keyword = filters.keyword || "";
            this.listing_length = filters.listing_length || 10;
            this.active_page_url = filters.active_page_url || null;

            // Clear stored filters
            localStorage.removeItem("patient_filters");

            // Fetch consultations using restored filters
            this.fetchPatients(this.active_page_url);
         } else {
            this.fetchPatients(); // Load normally if no stored filters
         }
      },
      methods: {
         clearLocalStorage() {
            localStorage.removeItem("consultation_filters");
            localStorage.removeItem("cancel_consultation_filters");
            localStorage.removeItem("doctor_filters");

         },
         handleProfileClick(id) {
            this.opt_button = 1;  // Set opt_button first
            this.getDetailsRoute(id);  // Then call the route function
         },
         handleMembersClick(id) {
            this.opt_button = 2;  // Set opt_button first
            this.getDetailsRoute(id);  // Then call the route function
         },
         handleBookingsClick(id) {
            this.opt_button = 3;  // Set opt_button first
            this.getDetailsRoute(id);  // Then call the route function
         },
         handleRecordClick(id) {
            this.opt_button = 4;  // Set opt_button first
            this.getDetailsRoute(id);  // Then call the route function
         },
         getDetailsRoute(id) {
            const filters = {
               keyword: this.keyword,
               listing_length: this.listing_length,
               active_page_url: this.active_page_url || this.$route.fullPath, // Store last visited page
            };
            localStorage.setItem("patient_filters", JSON.stringify(filters)); // Save filters
            
            if (this.opt_button == 1) { // Now this check will pass
               this.$router.push({ name: "patients.details", params: { id: id } });
            }else if (this.opt_button == 2) { // Now this check will pass
               this.$router.push({ name: "patients.members", params: { id: id } });
            }else if (this.opt_button == 3) { // Now this check will pass
               this.$router.push({ name: "patients.bookings", params: { id: id } });
            }else if (this.opt_button == 4) { // Now this check will pass
               this.$router.push({ name: "patients.records", params: { id: id } });
            }
         },
         getToken() {
            if (localStorage.getItem('medicino_clinic')) {
               var medicino_clinic =  JSON.parse(localStorage.getItem('medicino_clinic'));
               if(medicino_clinic.token) {
                  this.token = medicino_clinic.token;
               } else {
                  this.$swal("", "Failed to fetch token, please login again", "error");
                  this.$router.push({ name: "login" });
               }
               
            } else {
               this.$swal("", "Session expired, please login again", "error");
               this.$router.push({ name: "login" });
            }
         }, 

         fetchPatients(page_url) {

            this.getToken();
            let url = "clinic/users?keyword=" + this.keyword + "&limit=" + this.listing_length;

            page_url = page_url || url;

            //if(localStorage.back_url) {
             //  page_url = localStorage.back_url;  
             //  localStorage.removeItem('back_url');
            //}    

            this.active_page_url = page_url;
            this.loading = true;
            
            this.$axios
               .get(page_url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  var responseData = res.data.data;
                  console.log(responseData);
                  this.patients = responseData.users.data;
      
                  this.pagination = responseData.users.links;
                  this.from = responseData.users.from;
                  this.to = responseData.users.to;
                  this.total = responseData.users.total;
               
            })
            .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        if(typeof error.response.data.message === 'object') {
                           console.log(error.response.status);
                        } else {
                           this.$swal("", error.response.data.message, "error");
                        }                        
                        
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
            })
            .finally(() => (this.loading = false));
         }, 
      }
   }
</script>
    
<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">
            <div class="card">
               <div class="card-body">
                  <!-- <h4 class="card-title"></h4>
                  <p class="card-title-desc"></p> -->

                  <!----- top button area starts---->
                  <div class="row mb-3">
                     <div class="col-12">
                        <router-link :to="{ name: 'patients.add' }" class="btn btn-primary float-end">Add User</router-link>
                     </div>
                  </div>
                  <!----- top button area ends---->

                  <!----- Listing length and search starts ----->
                  <div class="row mb-3">
                     <div class="col-sm-12 col-md-6">
                        <div class="listing-length" >
                           <label
                              >Show
                              <select class="form-control" v-model="listing_length" @change="fetchPatients()">
                                 <option value="5">5</option>
                                 <option value="10">10</option>
                                 <option value="15">15</option>
                              </select>
                              entries
                           </label>
                        </div>                        
                     </div>
                     <div class="col-sm-12 col-md-6">
                        <div class="listing-filter">
                           <label>
                              <input type="text" class="form-control" placeholder="Search" v-model="keyword" @keyup="fetchPatients()"/>
                           </label>
                        </div>                     
                        
                     </div>
                  </div>
                  <!----- Listing length and search ends ----->

                  <!---- listing table starts -------->
                  <div class="table-responsive">
                     <table class="table table-bordered mb-0">
                        <thead class="table-light">
                           <tr>
                              <th width="20%">Name</th>              
                              <th width="20%">Contact</th>
                              <th width="10%">Gender</th>               
                              <th width="20%">Created On</th>
                              <th width="30%">Options</th>
                           </tr>
                        </thead>
                        <tbody v-if="Boolean(patients.length)">
                           <tr v-for="(patient) in patients" :key="patient.id">
                              <td>{{patient.name}}</td>                      
                              <td>
                                 {{patient.country_code}} {{patient.mobile}}<br>
                                 {{patient.email}}<br>
                              </td>
                              <td>
                                 <span v-if="patient.gender==1">Male</span>
                                 <span v-if="patient.gender==2">Female</span>
                                 <span v-if="patient.gender==3">Others</span>
                              </td>
                              <td>{{patient.converted_created_at}}</td>
                             
                              <td>
                                 <!--<router-link :to="{ name: 'patients.details', params: {id: patient.patient_id, name: patient.name} }" class="btn btn-primary me-2 mb-2 btn-sm">Profile</router-link>-->
                                  <button @click="handleProfileClick(patient.patient_id)" class="btn btn-primary me-2 mb-2 btn-sm" type="button">Profile</button>

                                 <!--<router-link :to="{ name: 'patients.members', params: {id: patient.patient_id}  }" class="btn btn-primary me-2 mb-2 btn-sm">Members</router-link>-->
                                 
                                 <button @click="handleMembersClick(patient.patient_id)" class="btn btn-primary me-2 mb-2 btn-sm" type="button">Members</button>

                                 <!--<router-link :to="{ name: 'patients.bookings', params: {id: patient.patient_id}  }" class="btn btn-primary me-2 mb-2 btn-sm">Bookings</router-link> -->     
                                  <button @click="handleBookingsClick(patient.patient_id)" class="btn btn-primary me-2 mb-2 btn-sm" type="button">Bookings</button>

                                 <!--<router-link :to="{ name: 'patients.records', params: {id: patient.patient_id}  }" class="btn btn-primary me-2 mb-2 btn-sm">Records</router-link>-->
                                 <button @click="handleRecordClick(patient.patient_id)" class="btn btn-primary me-2 mb-2 btn-sm" type="button">Records</button>

                                 <router-link :to="{ name: 'consultations.add',  params: {patient_id: patient.patient_id, name: patient.name} }" class="btn btn-primary me-2 mb-2 btn-sm">Add Consultation</router-link>
                                
                              </td>
                           </tr>
                 
                        </tbody>

                        <tbody v-else>
                           <tr>
                              <td colspan="5" class="text-center">No patients found</td>
                           </tr>
                        </tbody>
                     </table>
                  </div>
                  <!---- listing table ends -------->

                  <!----pagination starts --->     
                  <caption v-if="Boolean(patients.length)" class="float-start mt-4 d-block d-lg-inline">Showing {{this.from}} to {{this.to}} of {{this.total}} entries</caption>               
                  <ul class="pagination pagination-rounded mt-4 float-lg-end d-md-inline-flex">
                     <li class="page-item "  v-bind:class="[{disabled: !page.url}, {active: page.active}]" v-for="(page, index) in pagination" :key="page.label">
                        <a href="#" class="page-link" @click.prevent="fetchPatients(page.url + '&limit='+ listing_length + '&keyword=' + keyword + '&status=' + status )">
                           <i v-if="index == 0" class="mdi mdi-chevron-left"></i>
                           <i v-else-if="index == pagination.length-1" class="mdi mdi-chevron-right"></i>
                           <span v-else>{{page.label}}</span>                          
                        </a>
                     </li>
                  </ul>
                  <!----pagination ends --->

               </div>
            </div>
         </div>
      </div>
   </Layout>
</template>
